var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecentralizedSignalPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4677,
    cy: 20.4355,
    r: 6.41935,
    stroke: "url(#paint0_linear_648_1442)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.8227,
    cy: 17.9194,
    r: 6.41935,
    stroke: "url(#paint1_linear_648_1442)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.8549,
    cy: 48.1127,
    r: 6.41935,
    stroke: "url(#paint2_linear_648_1442)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.9194,
    cy: 82.081,
    r: 6.41935,
    stroke: "url(#paint3_linear_648_1442)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9194,
    cy: 68.2421,
    r: 6.41935,
    stroke: "url(#paint4_linear_648_1442)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.113,
    cy: 48.1127,
    r: 6.41935,
    stroke: "url(#paint5_linear_648_1442)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.113,
    cy: 82.081,
    r: 6.41935,
    stroke: "url(#paint6_linear_648_1442)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3872 19.8062L66.9033 17.29",
    stroke: "url(#paint7_linear_648_1442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4517 24.8384L76.9678 41.1932",
    stroke: "url(#paint8_linear_648_1442)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1292 23.5806L71.9356 44.9677",
    stroke: "url(#paint9_linear_648_1442)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4839 55.0322L85.7742 75.1613",
    stroke: "url(#paint10_linear_648_1442)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0322 47.4839H71.9355",
    stroke: "url(#paint11_linear_648_1442)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7742 52.5161L83.258 78.9355",
    stroke: "url(#paint12_linear_648_1442)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4518 51.2583L16.5808 62.5809",
    stroke: "url(#paint13_linear_648_1442)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3225 27.355L11.5483 61.3227",
    stroke: "url(#paint14_linear_648_1442)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6128 26.0967L35.4515 43.7096",
    stroke: "url(#paint15_linear_648_1442)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5808 72.645L34.1937 78.9353",
    stroke: "url(#paint16_linear_648_1442)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0322 82.71H82",
    stroke: "url(#paint17_linear_648_1442)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_648_1442",
    x1: 25.3871,
    y1: 14.85,
    x2: -1.54008,
    y2: 35.3579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_648_1442",
    x1: 80.742,
    y1: 12.3339,
    x2: 53.8149,
    y2: 32.8418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_648_1442",
    x1: 85.7743,
    y1: 42.5272,
    x2: 58.8471,
    y2: 63.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_648_1442",
    x1: 95.8387,
    y1: 76.4955,
    x2: 68.9116,
    y2: 97.0034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_648_1442",
    x1: 17.8387,
    y1: 62.6566,
    x2: -9.08842,
    y2: 83.1646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_648_1442",
    x1: 48.0323,
    y1: 42.5272,
    x2: 21.1052,
    y2: 63.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_648_1442",
    x1: 48.0323,
    y1: 76.4955,
    x2: 21.1052,
    y2: 97.0034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_648_1442",
    x1: 66.9033,
    y1: 17.5326,
    x2: 66.1002,
    y2: 27.6256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_648_1442",
    x1: 76.9678,
    y1: 26.4147,
    x2: 69.3369,
    y2: 27.3089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_648_1442",
    x1: 71.9356,
    y1: 25.642,
    x2: 34.232,
    y2: 89.8294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_648_1442",
    x1: 85.7742,
    y1: 56.9724,
    x2: 67.4718,
    y2: 61.3284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_648_1442",
    x1: 71.9355,
    y1: 47.5803,
    x2: 71.7144,
    y2: 51.6049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_648_1442",
    x1: 83.258,
    y1: 55.0626,
    x2: 30.0016,
    y2: 111.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_648_1442",
    x1: 35.4518,
    y1: 52.3496,
    x2: 13.2335,
    y2: 80.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_648_1442",
    x1: 15.3225,
    y1: 30.629,
    x2: 3.80153,
    y2: 31.6039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_648_1442",
    x1: 35.4515,
    y1: 27.7943,
    x2: 4.12358,
    y2: 46.5412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_648_1442",
    x1: 34.1937,
    y1: 73.2513,
    x2: 24.4328,
    y2: 94.0666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_648_1442",
    x1: 82,
    y1: 82.8063,
    x2: 81.8442,
    y2: 86.8371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecentralizedSignalPortfolio);
export default __webpack_public_path__ + "static/media/decentralized-signal-portfolio.88a53e20f222bc172601fa8d1e1e19bb.svg";
export { ForwardRef as ReactComponent };